import React, { useEffect, useState } from "react";
import {
  Button,
  Flex,
  Text,
  Icon,
  useDisclosure,
} from "@chakra-ui/react";
import { MdEdit } from "react-icons/md";
import useAxios from "axios-hooks";
import logger from "infra/logger";
import PropertyOwnerDetailsModal from "./PropertyOwnerDetailsModal";
import RoleBasedRender from "components/wrappers/roleBasedRender";
import { onlyAdmins } from "utils/accessLevels";

// PropertyOwnerDetails component to display name and edit button
const PropertyOwnerDetails = ({ station }) => {
  // State for the modal
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [propertyOwner, setPropertyOwner] = useState(null);

  const [{ data, loading, error }, execute] = useAxios(
    {
      method: "GET",
      url: `/api/userStationAccess/powner/station/${station?.Id}`,
    },
    { manual: true }
  );

  const getPropertyOwnerDetails = async () => {
    try {
      const response = await execute();
      const ownerData = response.data.data;
      setPropertyOwner(ownerData);
    } catch (error) {
      logger.log(error);
    }
  };

  // Use the provided name or default to "NA"
  const displayName = propertyOwner
    ? `${propertyOwner?.FirstName || ""} ${
        propertyOwner?.LastName || ""
      }`.trim()
    : "Not Assigned";

  useEffect(() => {
    getPropertyOwnerDetails();
  }, []);

  return (
    <>
      {/* Display name and edit button */}
      <Flex align="center" justify="space-between">
        <Text>{displayName}</Text>
        <RoleBasedRender roles={onlyAdmins}>
          <Button
            size="sm"
            variant="ghost"
            colorScheme="orange"
            onClick={onOpen}
            ml={2}
            p={1}
            minW="auto"
            _hover={{
              bg: "rgba(245, 125, 54, 0.1)",
              transform: "translateY(-2px)",
              boxShadow: "0 4px 12px rgba(245, 125, 54, 0.15)",
            }}
          >
            <Icon as={MdEdit} color="#f57d36" boxSize={4} />
          </Button>
        </RoleBasedRender>
      </Flex>

      {/* Modal for editing property owner details */}
      <PropertyOwnerDetailsModal
        isOpen={isOpen}
        onClose={onClose}
        powner={propertyOwner}
        station={station}
        refresh={getPropertyOwnerDetails}
      />
    </>
  );
};

export default PropertyOwnerDetails;
